module.exports = __webpack_public_path__ + "img/major_hazard.e38fc160.svg";